module.exports = __webpack_public_path__ + "static/media/price-fr.ca766353.png";